<div id="simple-text-icon-list-container">
    <div class="list-entry" *ngFor="let entry of entries" (click)="!!entry.action ? entry.action() : null">
        <p>{{ entry.text }}</p>
        <mat-icon *ngIf="!!entry.icon">{{ entry.icon }}</mat-icon>
    </div>
</div>